import { render, staticRenderFns } from "./message.vue?vue&type=template&id=42dacce6&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=42dacce6&prod&lang=css"
import style1 from "./message.vue?vue&type=style&index=1&id=42dacce6&prod&scoped=true&lang=less"
import style2 from "./message.vue?vue&type=style&index=2&id=42dacce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dacce6",
  null
  
)

export default component.exports